<template>
    <ion-page v-if="action">
        <ion-header class="ion-no-border">
            <ion-toolbar color="custom-white">
                <ion-buttons slot="start">
                    <ion-button color="primary" @click="back()">
                        <mdicon class="icon" name="arrow-left" />
                    </ion-button>
                </ion-buttons>
                <ion-title>
                    Actie
                </ion-title>

                <ion-buttons slot="end">
                    <!-- <ion-button mode="ios" fill="outline" shape="round" @click="actionDone()" color="primary"
                        v-if="action.status != 'DONE'">
                        Voltooi
                    </ion-button> -->

                    <ion-button color="primary" @click="updateAction()">
                        <mdicon class="mr-1 small-icon" name="content-save-outline" />
                        Opslaan
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>

            <!-- ion segment edit and comments -->
            <!-- <ion-toolbar color="custom-white">
                <ion-segment mode="ios" value="comments" v-model="mode">
                    <ion-segment-button value="comments">
                        <ion-label>Opmerkingen</ion-label>
                    </ion-segment-button>
                    <ion-segment-button value="edit">
                        <ion-label>Bewerken</ion-label>
                    </ion-segment-button>
                </ion-segment>
            </ion-toolbar> -->
        </ion-header>

        <ion-content color="light">

            <!-- <div v-if="mode == 'comments'">
                <Comments :action="action" />
            </div> -->

            <ion-list :inset="true">
                <ion-item>
                    <ion-input mode="ios" class="lg" placeholder="Naam" v-model="action.name"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-textarea mode="ios" :spellcheck="true" :autoGrow="false" :rows="10" placeholder="Beschrijving" v-model="action.description"></ion-textarea>
                </ion-item>
                <ion-item>
                    <ion-label position="stacked">Prioriteit</ion-label>
                    <ion-select mode="ios" v-model="action.priority" placeholder="Prioriteit" cancelText="Annuleren">
                        <ion-select-option value="LOW">Laag</ion-select-option>
                        <ion-select-option value="MEDIUM"> Normaal </ion-select-option>
                        <ion-select-option value="HIGH">Hoog</ion-select-option>
                    </ion-select>
                </ion-item>

                <ion-item class="input-right-align">
                    <ion-label>Moet opgelost voor</ion-label>
                    <ion-datetime-button presentation="date" datetime="due_date"></ion-datetime-button>

                    <!-- show backdrop -->
                    <ion-modal mode="ios" :keep-contents-mounted="true">
                        <ion-datetime mode="ios" presentation="date" slot="end" :value="getDate(action.due_date)" id="due_date" showDefaultButtons @ionChange="action.due_date = $event.detail.value" cancelText="Annuleren" doneText="Bevestigen">
                        </ion-datetime>
                    </ion-modal>
                </ion-item>

                <ion-item>
                    <ion-label position="stacked">Actie status</ion-label>
                    <ion-select mode="ios" v-model="action.status" placeholder="Geen waarde" cancelText="Annuleren">
                        <ion-select-option value="OPEN">Open</ion-select-option>
                        <ion-select-option value="PENDING">In uitvoering</ion-select-option>
                        <ion-select-option value="DONE">Voltooid</ion-select-option>
                    </ion-select>
                </ion-item>

                <!-- members multiple select -->
                <ion-item>
                    <ion-label position="stacked">Betrokken collega's</ion-label>
                    <ion-select mode="ios" v-model="action.member_ids" placeholder="Geen waarde" cancelText="Annuleren" multiple>
                        <ion-select-option v-for="user in inspection.members" :key="user.id" :value="user.id">
                            {{ user.name }}
                        </ion-select-option>
                    </ion-select>
                </ion-item>

                <!-- go to module, based on type -->
                <div class="ma-3">
                    <ion-button @click="openInspection()" color="primary" fill="outline" expand="block" class="ma-y">
                        Ga naar inspectie
                    </ion-button>

                    <!-- delete button -->
                    <ion-button @click="deleteAction()" color="danger" fill="outline" expand="block" class="my-6">
                        <mdicon class="icon" slot="start" name="trash-can-outline" />
                        Verwijderen
                    </ion-button>
                </div>

            </ion-list>

        </ion-content>

    </ion-page>
</template>
<script>
import { add, list, albumsOutline, save, close, chevronBack, shieldCheckmark, createOutline } from 'ionicons/icons';
import { db } from "@/services/db";
import uuid from '@/plugins/uuid'
import { alertController } from '@ionic/core';


export default {
    name: 'update-action',
    components: {
    },
    data() {
        return {
            mode: 'comments',
            createOutline,
            shieldCheckmark,
            add,
            list,
            albumsOutline,
            save,
            close,
            chevronBack,
            users: [],
            selected_inspection: null,
            inspections: [],
            subject: null,
            action: {
                name: '',
                description: '',
                priority: 'MEDIUM',
                due_date: '',
                status: 'OPEN',
                assigned_to: null,
                member_ids: [],
                inspection_id: null,
                created_by: null,
            },
            inspection: {
                members: []
            }
        }
    },
    ionViewWillEnter() {
        this.setup()
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        async setup() {
            this.action = await db.actions.where({ uuid: this.$route.query.uuid }).first()
            this.inspection = await db.inspections.where({ id: this.action.inspection_id }).first()
        },
        actionDone() {
            alertController.create({
                mode: 'ios',
                header: 'Actie voltooien',
                message: 'Weet je zeker dat je deze actie wilt voltooien?',
                buttons: [
                    {
                        text: 'Annuleren',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Confirm Cancel: blah');
                        },
                        role: 'cancel'
                    }, {
                        text: 'Voltooien',
                        handler: () => {
                            this.completeAction()
                        },
                        role: 'save'
                    }
                ]
            }).then(alert => {
                alert.present();
            });
        },
        completeAction() {
            this.action.status = 'DONE'
            this.updateAction()
        },
        async openInspection() {
            let inspection = await db.inspections.where({ id: this.action.inspection_id }).first()
            if (!inspection) return this.$toast.error('Inspectie niet gevonden')

            this.$store.dispatch('setInspectionId', inspection.id)
            this.$store.dispatch('setLocationId', inspection.location_id)
            this.$store.dispatch('setInspectionUuid', inspection.uuid)
            this.$store.dispatch('setLocationUuid', inspection.location_uuid)

            this.$router.push({
                name: 'inspection-show',
                params: {
                    id: inspection.id,
                },
                query: {
                    location_id: inspection.location_id,
                    inspection_uuid: inspection.uuid,
                    location_uuid: inspection.location_uuid,
                }
            })
        },
        getDate(date) {
            if (!date) return;
            return new Date(date).toISOString()
        },
        updateAction() {
            if (!this.action.name) return this.$toast.error('Actie titel is verplicht')
            if (!this.action.due_date) return this.$toast.error('Moet opgelost voor is verplicht')
            if (!this.action.inspection_id) return this.$toast.error('Koppelen aan inspectie is verplicht')
            if (!this.action.assigned_to) return this.$toast.error('Actie toewijzen is verplicht')

            let url = '/actions/' + this.action.uuid;
            let copy_action = JSON.parse(JSON.stringify(this.action))
            copy_action.due_date = this.action.due_date.split('T')[0]
            delete copy_action.created_by

            this.$requests.patch('actions', url, copy_action).then(() => {
                this.$toast.success('Actie opgeslagen')
                let new_user = this.inspection.members.find(user => user.id == this.action.assigned_to)
                if (new_user) {
                    this.createComment('ASSIGNED_TO', 'Toegewezen aan <strong>' + new_user.name + '</strong>')
                }
            })

            this.$router.go(-1)
        },
        createComment(type, message) {
            this.$requests.post('comments', '/actions/' + this.action.uuid + '/comments', {
                content: message,
                uuid: uuid(),
                type: type
            })
        },
        deleteAction() {
            alertController.create({
                mode: 'ios',
                header: 'Verwijderen',
                message: 'Weet je zeker dat je deze actie wilt verwijderen?',
                buttons: [
                    {
                        text: 'Annuleren',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Confirm Cancel: blah');
                        },
                        role: 'cancel'
                    }, {
                        text: 'Verwijderen',
                        handler: () => {
                            this.deleteConfirmed()
                        },
                        role: 'destructive'
                    }
                ]
            }).then(alert => {
                alert.present();
            });
        },
        deleteConfirmed() {
            let url = '/actions/' + this.action.uuid
            this.$requests.delete('actions', url, this.action.uuid).then(() => {
                this.$toast.success('Actie verwijderd')
                this.$router.go(-1)
            })

        },
    },
}
</script>
<style lang="">

</style>
